import { Box } from "@mui/material"
import { Order } from "./order/Index"

export const UBR = () =>{
    const loc = window.location.pathname
    return(
        <Box sx={{height: "100%"}}>
            <Components loc={loc}/>
        </Box>
    )
}

const Components = ({loc}) => {
    if (loc === '/ubr/order') { return <Order/>
    }else{return 'NOT FOUND'}
}

